module.exports = "/_next/static/files/557c2636be1a17c0f26565fadf146638.png";